import { useLocation } from 'react-router-dom';
import qs from 'query-string';

const useSearchParams = () => {
  const location = useLocation();
  return qs.parse(location.search);
};

export default useSearchParams;
